import { render, staticRenderFns } from "./PaymentMethodItemsList.vue?vue&type=template&id=09cebdec&scoped=true"
import script from "./PaymentMethodItemsList.vue?vue&type=script&lang=js"
export * from "./PaymentMethodItemsList.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodItemsList.vue?vue&type=style&index=0&id=09cebdec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_1ea54a5d08821f18e5f7625cad052d96/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cebdec",
  null
  
)

export default component.exports